import { Types } from './actions'
const innitialState = {
  isLoading: false,
  isReady: false,
  supplierId: null,
  redemptionPoints: 0,
  minimumRedemptionLimit: 0,
  maximumRedemptionLimit: 0,
  partners: [],
  configuration: [],
  calculator: { points: '', miles: '' },
  error: null
}

export default (state = innitialState, action) => {
  switch (action.type) {
    case Types.TOGGLE_SUPPLIER_ID:
      return {
        ...state,
        isReady: false,
        supplierId: action.supplierId
      }
    case Types.CHANGE_REDEMPTION_POINTS:
      return { ...state, redemptionPoints: action.redemptionPoints }
    case Types.CHANGE_MINIMUM_REDEMPTION_LIMIT:
      return {
        ...state,
        isReady:
          state.supplierId !== null &&
          action.minimumRedemptionLimit > 0 &&
          state.maximumRedemptionLimit > 0,
        minimumRedemptionLimit: action.minimumRedemptionLimit
      }
    case Types.CHANGE_MAXIMUM_REDEMPTION_LIMIT:
      return {
        ...state,
        isReady:
          state.supplierId !== null &&
          state.minimumRedemptionLimit > 0 &&
          action.maximumRedemptionLimit > 0,
        maximumRedemptionLimit: action.maximumRedemptionLimit
      }
    case 'FETCH_PARTNERS_STIX':
      return {
        ...state,
        partners: []
      }
    case 'FETCH_PARTNERS_STIX_SUCCESS':
      return {
        ...state,
        partners: action.payload.data
      }
    case 'FETCH_PARTNERS_STIX_FAIL':
      return {
        ...state,
        error: action.error
      }
    case 'FETCH_POINTS_TO_MILES':
      return {
        ...state,
        isLoading: true
      }
    case 'FETCH_POINTS_TO_MILES_SUCCESS':
      return {
        ...state,
        isLoading: false,
        error: null,
        calculator: action.payload.data
      }
    case 'FETCH_POINTS_TO_MILES_FAIL':
      return {
        ...state,
        isLoading: false,
        calculator: { ...state.calculator, miles: '' },
        error: action.error
      }

    case 'CONFIGURATION_STIX_PARTNERS':
      return {
        ...state,
        isLoading: false,
        enableConfiguration: false
      }

    case 'CONFIGURATION_STIX_PARTNERS_SUCCESS':
      const { configuration, partners } = state

      const supplierId = action.meta.previousAction.supplierId

      configuration[supplierId] = [...action.payload.data]

      const fidelityLabelConfig = vendorId => {
        const model = configuration[vendorId]

        if (model) {
          var filter = model.filter(x => x.key === 'LoyaltyNumberLabel')

          if (filter.length > 0) {
            return filter[0].value
          }
        } else {
          return ''
        }
      }

      return {
        ...state,
        isLoading: false,
        enableConfiguration: true,
        configuration: { ...configuration },
        partners:
          partners.map(p => ({
            ...p,
            fidelityLabel: fidelityLabelConfig(p.vendorId)
          })) || []
      }
    case 'CONFIGURATION_STIX_PARTNERS_FAIL':
      return {
        ...state,
        isLoading: false,
        enableConfiguration: false,
        error: action.error
      }
    case Types.CLOSE_ERROR_STIX:
      return {
        ...state,
        error: null
      }
    default:
      return state || innitialState
  }
}



// WEBPACK FOOTER //
// ./src/features/Stix/reducer.js